import { Box, Flex, Spinner, Text, Icon } from "@chakra-ui/react";
import FolderHeader from "./Header";
// [FIX] direct import — lazy() + Suspense causes React #321 with Chakra v2 + React 19
import Folder from "./Folder/FolderManualReport";

const renderFoldersRecursive = (Component, folders, props) => {
  if (!folders || !folders.length) return null;
  return folders.map((folderItem) => (
    <Component
      key={folderItem.FolderId}
      Item={folderItem}
      RenderFolders={renderFoldersRecursive}
      {...props}
    />
  ));
};

const FoldersManager = ({
  Props,
  OnRefetch,
  OnChange,
  OnSelect,
  OnToggleFolder,
  OpenFolders,
  Selected,
  texts = {} 
}) => {
  const { Folders = [], IsFoldersLoading } = Props || {};
  const fileManagerTexts = texts?.fileManager || {};

  return (
    <Box
      w={"100%"} 
      h="100%" 
      border="1px solid"
      borderRadius="md"
      display="flex"
      flexDirection="column"
      sx={{
        bg: 'var(--fm-sidebar-bg)',
        borderColor: 'var(--fm-sidebar-border)',
        color: 'var(--fm-sidebar-text)',
      }}
    >
      <FolderHeader
        OnRefetch={OnRefetch}
        OnChange={OnChange}
        Lang={{ Folder: { TITLE: fileManagerTexts.folders || "Folders" } }}
        texts={texts}
      />
      
      <Box 
        borderTop="1px solid" 
        flex="1"
        minH={0} 
        display="flex"
        flexDirection="column"
        sx={{ borderColor: 'var(--fm-sidebar-border)' }}
      >
      

        {IsFoldersLoading ? (
          <Flex flex="1" align="center" justify="center"><Spinner /></Flex>
        ) : (
          <Box
            flex="1" 
            overflowY={"auto"}
            overflowX={"auto"}
            sx={{
              '&::-webkit-scrollbar': { width: '10px', height: '10px' },
              '&::-webkit-scrollbar-track': { background: 'var(--fm-scrollbar-track-bg)' },
              '&::-webkit-scrollbar-thumb': { background: 'var(--fm-scrollbar-thumb-bg)', borderRadius: '10px', border: '2px solid transparent', backgroundClip: 'content-box' },
              '&::-webkit-scrollbar-thumb:hover': { background: 'var(--fm-scrollbar-thumb-hover-bg)' }
            }}
          >
            {Folders.length > 0 ? (
              <Box minW="max-content" pb={2}>
                {renderFoldersRecursive(Folder, Folders, { 
                  OnSelect, 
                  OnChange, 
                  OnToggleFolder, 
                  OpenFolders, 
                  Selected, 
                  level: 0,
                  texts 
                })}
              </Box>
            ) : (
              <Flex 
                h="full" 
                align="center" 
                justify="center" 
                sx={{ color: 'var(--fm-empty-text-color)' }}
              >
                {fileManagerTexts.noFoldersFound || "No folders found."}
              </Flex>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FoldersManager;